import { AxiosError, AxiosInstance, AxiosPromise } from "axios";

export interface RestClient {
  get<T>(url: string, options?: object): Promise<T | null>;
  delete<T>(url: string, options?: object): Promise<T | null>;
  post<T>(url: string, data: object, options?: object): Promise<T | null>;
  put<T>(url: string, data: object, options?: object): Promise<T | null>;
  patch<T>(url: string, data: object, options?: object): Promise<T | null>;
}

export interface RestClientError extends AxiosError {
  httpStatus: number;
  httpStatusText?: string;
  httpBody?: {
    message: string;
    result: number;
    status: number;
    errors?: string[];
    [key: string]: number | string | string[] | undefined;
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isRestClientError(arg: any): arg is RestClientError {
  return !!arg.httpStatus;
}

const dataOrNullPromise = <T>(
  axiosMethodPromise: AxiosPromise<T>,
): Promise<T | null> =>
  axiosMethodPromise
    .then(({ data }) => data)
    .catch((e: RestClientError) => {
      if (e && e.response && e.response.status) {
        e.httpStatus = e.response.status;
        e.httpStatusText = e.response.statusText;
        e.httpBody = e.response.data as RestClientError["httpBody"];
        return Promise.reject(e);
      }
      return Promise.reject(e);
    });

export default (axios: AxiosInstance): RestClient => ({
  get: (url, options) => dataOrNullPromise(axios.get(url, options)),
  post: (url, data, options) =>
    dataOrNullPromise(axios.post(url, data, options)),
  put: (url, data, options) => dataOrNullPromise(axios.put(url, data, options)),
  patch: (url, data, options) =>
    dataOrNullPromise(axios.patch(url, data, options)),
  delete: (url, options) => dataOrNullPromise(axios.delete(url, options)),
});
